import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'core-js/modules/es6.regexp.split.js';
import * as React from 'react';
import { Classes } from '@blueprintjs/core';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var POPOVER_ARROW_SVG_SIZE = 30;
var TOOLTIP_ARROW_SVG_SIZE = 22;
var SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378" + "-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005" + "c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

function getArrowAngle(placement) {
  if (placement == null) {
    return 0;
  } // can only be top/left/bottom/right - auto is resolved internally


  switch (getBasePlacement(placement)) {
    case "top":
      return -90;

    case "left":
      return 180;

    case "bottom":
      return 90;

    default:
      return 0;
  }
}
/**
 * Popper's builtin "arrow" modifier options.padding doesn't seem to work for us, so we
 * need to compute our own offset in the direction of the popover relative to the reference.
 */


function getArrowReferenceOffsetStyle(placement) {
  var offset = POPOVER_ARROW_SVG_SIZE / 2 - 4;

  switch (getBasePlacement(placement)) {
    case "top":
      return {
        bottom: -offset
      };

    case "left":
      return {
        right: -offset
      };

    case "bottom":
      return {
        top: -offset
      };

    default:
      return {
        left: -offset
      };
  }
}

function getTooltipArrowReferenceOffsetStyle(placement) {
  var offset = TOOLTIP_ARROW_SVG_SIZE / 2 - 3;

  switch (getBasePlacement(placement)) {
    case "top":
      return {
        bottom: -offset
      };

    case "left":
      return {
        right: -offset
      };

    case "bottom":
      return {
        top: -offset
      };

    default:
      return {
        left: -offset
      };
  }
}

var Arrow = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      placement = _ref.placement;
  return (
    /*#__PURE__*/
    // data attribute allows popper.js to position the arrow
    React.createElement("div", {
      className: Classes.POPOVER_ARROW,
      "data-popper-arrow": true,
      ref: ref,
      style: _objectSpread(_objectSpread({}, style), placement && getArrowReferenceOffsetStyle(placement))
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 ".concat(POPOVER_ARROW_SVG_SIZE, " ").concat(POPOVER_ARROW_SVG_SIZE),
      style: {
        transform: "rotate(".concat(getArrowAngle(placement), "deg)")
      }
    }, /*#__PURE__*/React.createElement("path", {
      className: "bp3-popover-arrow-border",
      d: SVG_SHADOW_PATH
    }), /*#__PURE__*/React.createElement("path", {
      className: "bp3-popover-arrow-fill",
      d: SVG_ARROW_PATH
    })))
  );
});
var TooltipArrow = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var style = _ref2.style,
      placement = _ref2.placement;
  return (
    /*#__PURE__*/
    // data attribute allows popper.js to position the arrow
    React.createElement("div", {
      className: Classes.POPOVER_ARROW,
      "data-popper-arrow": true,
      ref: ref,
      style: _objectSpread(_objectSpread({}, style), placement && getTooltipArrowReferenceOffsetStyle(placement))
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 ".concat(POPOVER_ARROW_SVG_SIZE, " ").concat(POPOVER_ARROW_SVG_SIZE),
      style: {
        transform: "rotate(".concat(getArrowAngle(placement), "deg)")
      }
    }, /*#__PURE__*/React.createElement("path", {
      className: "bp3-popover-arrow-border",
      d: SVG_SHADOW_PATH
    }), /*#__PURE__*/React.createElement("path", {
      className: "bp3-popover-arrow-fill",
      d: SVG_ARROW_PATH
    })))
  );
});

export { Arrow, POPOVER_ARROW_SVG_SIZE, TOOLTIP_ARROW_SVG_SIZE, TooltipArrow };
//# sourceMappingURL=arrow.js.map
